import { Popover } from 'react-tiny-popover';
import styled, { css } from 'styled-components';

export const StyledDefaultPopover = styled(Popover)``;

export const StyledSearchBarWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  height: fit-content;
  flex-wrap: nowrap;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.white};
  cursor: pointer;
  user-select: none;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding: 20px 0px;
  }
`;

export const SearchBarInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: fit-content;
  flex-wrap: nowrap;
  padding: 17px;
`;

export const SearchBarLabel = styled.div<{
  isActive?: boolean;
  isFilled?: boolean;
}>`
  ${({ isFilled, isActive }) =>
    !isActive &&
    isFilled &&
    css`
      opacity: 0.5;
    `};
  font-size: 12px;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${({ theme }) => theme.palette.darkGrey};
  opacity: 0.5;
`;

export const SearchBarInputText = styled.div<{
  isActive?: boolean;
  isFilled?: boolean;
}>`
  font-size: 12px;
  font-weight: 600;
  text-overflow: inherit;
  white-space: inherit;
  overflow: inherit;
`;

export const IconRightSpace = styled.div`
  width: 15px;
`;

export const InputContentWrapper = styled.div`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const RenderOverlayContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  cursor: auto;
`;

SearchBarLabel.defaultProps = {
  isActive: false,
};
